import { FavouriteSectionType } from 'app/area/favourite-administration/form/metroline/types';
import { selectorId } from 'app/area/shared/selector-id';
import { DefaultContainerProps } from 'app/infrastructure/redux';
import { FavouriteAdminState } from '../types-store';
import { hasChanges } from './utils/has-changes';

export interface FavouriteFormSelectorProps {
  id: number;
  favouriteId: number;
  shouldPrompt: boolean;
  section: FavouriteSectionType;
}

type FavouriteFormSelectors = { [T in keyof FavouriteFormSelectorProps]?:
  (state: FavouriteAdminState, props: DefaultContainerProps) => FavouriteFormSelectorProps[T] };

export const selectors: FavouriteFormSelectors = {
  shouldPrompt: ({ form }) =>
    hasChanges(form?.favouriteItem, form?.originalFavouriteItem),
  id: (_, { params }) => selectorId(params?.id),
  section: (_, { params }) =>
    params?.section || undefined
};
